// CCS for the card - light is completed

export const themeSwitch = {
  light: {
    backgroundColor: 'white',
    color: 'black',
  },
  dark: {
    backgroundColor: 'lightgrey',
    color: '#585858',
  },
};

// CSS for the centre dots- light is completed
export const dotSwitch = {
  light: {
    backgroundColor: 'white',
    color: '#f7797d',
  },
  dark: {
    backgroundColor: 'lightgrey',
    color: '#585858',
  },
};
